import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';
import { isConnectedAccount } from 'owa-accounts-store';
import { MailboxInfo, MailboxType } from 'owa-client-ids';
import { getConnectedAccountHeaders } from 'owa-connected-account-headers';

export async function getDefaultRequestHeaders(
    mailboxInfo: MailboxInfo
): Promise<{ [headerName: string]: string }> {
    if (mailboxInfo) {
        if (isConnectedAccount(mailboxInfo.userIdentity)) {
            return await getConnectedAccountHeaders(
                mailboxInfo.userIdentity,
                mailboxInfo.type == MailboxType.GroupMailbox ||
                    mailboxInfo.type == MailboxType.TeamsMailbox
                    ? mailboxInfo.mailboxSmtpAddress
                    : null
            );
        } else {
            if (
                mailboxInfo.type == MailboxType.GroupMailbox ||
                mailboxInfo.type == MailboxType.TeamsMailbox
            ) {
                return getExplicitLogonHeaders(mailboxInfo.mailboxSmtpAddress);
            }
        }
    }
    return {};
}
